import * as React from "react";

export class Col extends React.Component<{ modifier?: string }, {}> {
    constructor(props) {
        super(props)
    }

    render() {
        let cls = "rj-racing-next-races__col" + (this.props.modifier ? ` ${this.props.modifier}` : "");
        return (
            <div className={cls}>
                {this.props.children}
            </div>
        )
    }
}